export class SucheError extends Error {
  constructor(
    message: string,
    public cause: Error
  ) {
    super(message);
    this.name = 'SucheError';
    this.stack += `\nCaused by: ${cause.name} ${cause.message}\n` + cause.stack;
  }
}
